import styled from "@emotion/styled";


export const DashboardContainer = styled.div`
    z-index: 1;
    max-width: 1440px;
    margin-top: 30px;
    margin-right: auto;
    margin-left: auto;
    overflow-x: hidden;

    @media screen and (max-width: 1008px) {
        padding-right: 10px;
        padding-left: 10px;
        max-width: 100%;
    }
`;

export const StatsDivider = styled.div`
  width: 100%;
  height: 1px;
  background: #29384D;
  margin: 22px 0 14px 0;
`;
    
export const StatsSection = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 0;
`;

export const StatsTopBar = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 0 10px 0;
`;

export const StatsTitleLeft = styled.h2`
    margin: 0;
    font-size: ${({ theme }) => theme.fontSizes.h3};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.colors.text.primary};
`;

export const TimeSelectorWrap = styled.div`
    width: 220px;
    min-width: 220px;
    display: flex;
    justify-content: flex-end;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 100%;
        min-width: 0;
    }
`;

/** Row of 3 equal blocks */
export const CounterBlock = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 0;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    margin-top: 8px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: 1fr;
    }
`;

export const CounterStatsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
`;

/** Pie charts row */
export const ChartsBlock = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 26px;
  margin-top: 48px;
  margin-bottom: 48px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: 18px;
  }
`;
